/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseRecharge } from '../../models/api-response-recharge';
import { Recharge } from '../../models/recharge';

export interface CreateRecharge$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Recharge
}

export function createRecharge(http: HttpClient, rootUrl: string, params: CreateRecharge$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseRecharge>> {
  const rb = new RequestBuilder(rootUrl, createRecharge.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseRecharge>;
    })
  );
}

createRecharge.PATH = '/v1/api/ui/meta-pricing-analytics/recharge';
